@defer {
  <ngx-monaco-diff-editor [options]="options()"
                          [originalModel]="originalModel()"
                          [modifiedModel]="modifiedModel()"
                          (onInit)="initEditor($event)"
                          [style.width]="fullHeight() ? '100%' : 'min(1200px, 90vw)'"
                          [style.height]="fullHeight() ? '100%' : 'min(400px, 70vh)'"
                          [appResizeHandle]="resizable()"
                          [hitArea]="config.mobile() ? 48 : 20" />
}
